import { render } from "./ShowView.vue?vue&type=template&id=22c84782&scoped=true"
import script from "./ShowView.vue?vue&type=script&lang=js"
export * from "./ShowView.vue?vue&type=script&lang=js"

import "./ShowView.vue?vue&type=style&index=0&id=22c84782&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c84782"]])

export default __exports__